var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClockRounded = function SvgClockRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#691B33",
    fillRule: "evenodd",
    d: "M5.067 4.224a6.76 6.76 0 0 1 9.548 0 6.76 6.76 0 0 1 0 9.549 6.707 6.707 0 0 1-4.774 1.977 6.709 6.709 0 0 1-4.774-1.977.53.53 0 1 1 .749-.75 5.657 5.657 0 0 0 4.025 1.668c1.52 0 2.95-.592 4.025-1.667a5.7 5.7 0 0 0 0-8.051 5.7 5.7 0 0 0-8.05 0 5.661 5.661 0 0 0-1.641 3.54l.676-.628a.53.53 0 1 1 .721.777l-1.65 1.532a.528.528 0 0 1-.748-.028L1.64 8.516a.53.53 0 0 1 .776-.72l.688.74c.11-1.629.8-3.15 1.962-4.312Zm5.038 4.666H12.2a.53.53 0 0 1 0 1.058H9.576a.529.529 0 0 1-.53-.529V5.297a.529.529 0 0 1 1.059 0V8.89Z",
    clipRule: "evenodd"
  })));
};
export default SvgClockRounded;